import config from "../temp/config";
import _ from "lodash";
import querystring from "querystring";
import Md5 from "crypto-js/md5";
export const BASE_URI = config.webSettings?.apiHost + "/api/";
export const CONTENT_TYPES = {
  json: "application/json",
  form: "application/x-www-form-urlencoded; charset=UTF-8",
  file: "multipart/form-data",
  xml: "text/xml"
};
export const buildApiOptions = (path, contentType, params, body, opts) => {
  const str = path.split(" ");
  const method = str[0];
  let url = str[1];
  if (!/^(http|https)/.test(url)) {
    url = BASE_URI + url;
  } else if (/^~/.test(url)) {
    url = url.substr(1);
  }
  params = Object.assign(params || {}, {
    sc_apikey: config.webSettings.apiKey
  });
  if (method === "GET") {
    params = Object.assign(params || {}, {
      _t: Math.floor(Math.random() * 10000000)
    });
  }
  let options = {
    headers: {
      // "Ocp-Apim-Subscription-Key": config.webSettings.apiKey
    }
  };

  const pathNames = [];
  url = url.replace(/{(\w|_)(\d|\w|_)*}/gi, match => {
    const pathName = match.substr(1, match.length - 2);
    if (pathNames.indexOf(pathName) === -1) {
      pathNames.push(pathName);
    }
    if (params && params[pathName]) {
      return params[pathName];
    }
    if (body && body[pathName]) {
      return body[pathName];
    }
  });
  for (let pathName of pathNames) {
    if (params && params[pathName]) {
      delete params[pathName];
    }
    if (body && body[pathName]) {
      delete body[pathName];
    }
  }
  if (contentType) {
    options.headers["Content-Type"] = contentType;
    switch (contentType) {
      case CONTENT_TYPES.file:
        options.data = new FormData();
        for (const key of Object.keys(body)) {
          options.data.append(key, body[key]);
        }
        options.headers["X-Requested-With"] = "XMLHttpRequest";
        break;
      case CONTENT_TYPES.form:
        options.transformRequest = [
          function(data) {
            return querystring.stringify(data);
          }
        ];
        break;
      default:
        options.data = body;
        break;
    }
  } else {
    options.data = body;
  }
  _.merge(options, opts);
  options.method = method;
  options.url = url;
  options.params = params;
  // console.log(path, options);
  return options;
};
/**
 * @typedef {Function} APIResolver
 * @argument {Object} params
 * @argument {Object} body
 * @return {Promise<BFResponse>} response
 */
export const getRequestKey = (path, contentType, params, data, opts) => {
  let str = `${path}${contentType}${params ? JSON.stringify(params) : ""}${data ? JSON.stringify(data) : ""}${opts ? JSON.stringify(opts) : ""}`;
  return Md5(str).toString();
};
